import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Stack, TableCell, TableCellProps, IconButton, Box, SxProps, Theme } from "@mui/material";

export type CollapsibleCellProps = {
    text: string;
    open: boolean;
    onClick: () => void;
    onTextClick?: () => void;
    sx?: SxProps<Theme>
} & TableCellProps;

export function CollapsibleCell({
    text,
    open,
    onClick,
    onTextClick,
    colSpan,
    sx,
    ...rest
}: CollapsibleCellProps) {


    return (
        <TableCell component="th" scope="row" colSpan={colSpan}>
            <Stack direction='row'>
                <IconButton
                    aria-label="expand row"
                    size="small"
                    sx={{marginRight: 1}}
                    onClick={() => onClick()}
                >
                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                </IconButton>

                <Box
                    component='span'
                    onClick={() => onTextClick && onTextClick()}
                    sx={{
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        cursor: onTextClick ? 'pointer' : undefined,
                        ...sx
                    }}>
                    {text}
                </Box>

            </Stack>
        </TableCell>
    );

    
}
